<template>
    <header>
        <div class="menu" v-if="pcVersion">
            <router-link :to="{name: 'home'}">
                <svg class="main-logo-shadow" width="140" height="24" viewBox="0 0 140 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.15501 4.08439H0V4.84388L8.99129 24H11.2691L20.1705 4.84388V4.08439H15.0155L10.2201 15.2236H10.0702L5.15501 4.08439Z"
                          fill="url(#paint0_linear)"/>
                    <path d="M28.931 19.3587V8.47257H31.3886C31.3886 6.78481 31.3886 5.74402 31.3886 4.08439C27.9719 4.08439 24.5852 4.08439 21.1685 4.08439C21.1685 5.74402 21.1685 6.78481 21.1685 8.47257H23.6261V19.3587H20.9587C20.9587 21.0183 20.9587 22.2841 20.9587 24C24.5253 24 28.0319 24 31.5984 24C31.5984 22.2841 31.5984 21.0183 31.5984 19.3587H28.931Z"
                          fill="url(#paint1_linear)"/>
                    <path d="M49.4071 24H51.3253V4.08439C49.4971 4.08439 47.6688 4.08439 45.8406 4.08439V13.7328L35.2309 4H33.2828V24C35.111 24 36.9692 24 38.8274 24V14.0985L49.4071 24Z"
                          fill="url(#paint2_linear)"/>
                    <path d="M66.7303 4.08439C61.815 4.08439 58.4882 4.08439 53.633 4.08439C53.633 10.6104 53.633 17.4177 53.633 24C58.4882 24 62.0848 24 67 24C67 22.5091 67 20.7651 67 19.3024C63.853 19.3024 62.0548 19.3024 58.9678 19.3024C58.9678 18.121 58.9678 16.9958 58.9678 15.8425H66.1009C66.1009 14.3516 66.1009 12.8608 66.1009 11.3699H58.9678V8.58509C62.0548 8.58509 63.6133 8.58509 66.7303 8.58509C66.7303 7.0661 66.7303 5.54712 66.7303 4.08439Z"
                          fill="url(#paint3_linear)"/>
                    <g filter="url(#filter0_i)">
                        <path d="M5.15501 2.08439H0V2.84388L8.99129 22H11.2691L20.1705 2.84388V2.08439H15.0155L10.2201 13.2236H10.0702L5.15501 2.08439Z"
                              fill="url(#paint4_linear)"/>
                        <path d="M28.931 17.3587V6.47257H31.3886C31.3886 4.78481 31.3886 3.74402 31.3886 2.08439C27.9719 2.08439 24.5852 2.08439 21.1685 2.08439C21.1685 3.74402 21.1685 4.78481 21.1685 6.47257H23.6261V17.3587H20.9587C20.9587 19.0183 20.9587 20.2841 20.9587 22C24.5253 22 28.0319 22 31.5984 22C31.5984 20.2841 31.5984 19.0183 31.5984 17.3587H28.931Z"
                              fill="url(#paint5_linear)"/>
                        <path d="M49.4071 22H51.3253V2.08439C49.4971 2.08439 47.6688 2.08439 45.8406 2.08439V11.7328L35.2309 2H33.2828V22C35.111 22 36.9692 22 38.8274 22V12.0985L49.4071 22Z"
                              fill="url(#paint6_linear)"/>
                        <path d="M66.7303 2.08439C61.815 2.08439 58.4882 2.08439 53.633 2.08439C53.633 8.61041 53.633 15.4177 53.633 22C58.4882 22 62.0848 22 67 22C67 20.5091 67 18.7651 67 17.3024C63.853 17.3024 62.0548 17.3024 58.9678 17.3024C58.9678 16.121 58.9678 14.9958 58.9678 13.8425H66.1009C66.1009 12.3516 66.1009 10.8608 66.1009 9.3699H58.9678V6.58509C62.0548 6.58509 63.6133 6.58509 66.7303 6.58509C66.7303 5.0661 66.7303 3.54712 66.7303 2.08439Z"
                              fill="url(#paint7_linear)"/>
                    </g>
                    <path d="M79.4329 12.6648L71.0252 4.02841H69V23.9716C70.8718 23.9716 72.7436 23.9716 74.6153 23.9716V15.108L79.1567 19.5398H79.7704L84.3425 15.108V23.9716C86.2142 23.9716 88.086 23.9716 89.9578 23.9716V4.02841H87.994L79.4329 12.6648Z"
                          fill="url(#paint8_linear)"/>
                    <path d="M99.8307 19.5114V8.51705H102.347C102.347 6.8125 102.347 5.76136 102.347 4.08523C98.8488 4.08523 95.3814 4.08523 91.8833 4.08523C91.8833 5.76136 91.8833 6.8125 91.8833 8.51705H94.3995V19.5114H91.6685C91.6685 21.1875 91.6685 22.2386 91.6685 23.9716C95.32 23.9716 98.9102 23.9716 102.562 23.9716C102.562 22.2386 102.562 21.1875 102.562 19.5114H99.8307Z"
                          fill="url(#paint9_linear)"/>
                    <path d="M120.988 24H122.952V4.08523C121.08 4.08523 119.208 4.08523 117.337 4.08523V13.8295L106.474 4H104.48V23.9716C106.351 23.9716 108.254 23.9716 110.156 23.9716V14.1989L120.988 24Z"
                          fill="url(#paint10_linear)"/>
                    <path d="M138.724 4.08523C133.692 4.08523 130.285 4.08523 125.315 4.08523C125.315 10.6761 125.315 17.3239 125.315 23.9716C130.285 23.9716 133.968 23.9716 139 23.9716C139 22.4659 139 20.9318 139 19.4545C135.778 19.4545 133.937 19.4545 130.776 19.4545C130.776 18.2614 130.776 17.125 130.776 15.9602H138.079C138.079 14.4545 138.079 12.9489 138.079 11.4432H130.776V8.63068C133.937 8.63068 135.533 8.63068 138.724 8.63068C138.724 7.09659 138.724 5.5625 138.724 4.08523Z"
                          fill="url(#paint11_linear)"/>
                    <g filter="url(#filter1_i)">
                        <path d="M79.4329 10.6648L71.0252 2.02841H69V21.9716C70.8718 21.9716 72.7436 21.9716 74.6153 21.9716V13.108L79.1567 17.5398H79.7704L84.3425 13.108V21.9716C86.2142 21.9716 88.086 21.9716 89.9578 21.9716V2.02841H87.994L79.4329 10.6648Z"
                              fill="url(#paint12_linear)"/>
                        <path d="M99.8307 17.5114V6.51705H102.347C102.347 4.8125 102.347 3.76136 102.347 2.08523C98.8488 2.08523 95.3814 2.08523 91.8833 2.08523C91.8833 3.76136 91.8833 4.8125 91.8833 6.51705H94.3995V17.5114H91.6685C91.6685 19.1875 91.6685 20.2386 91.6685 21.9716C95.32 21.9716 98.9102 21.9716 102.562 21.9716C102.562 20.2386 102.562 19.1875 102.562 17.5114H99.8307Z"
                              fill="url(#paint13_linear)"/>
                        <path d="M120.988 22H122.952V2.08523C121.08 2.08523 119.208 2.08523 117.337 2.08523V11.8295L106.474 2H104.48V21.9716C106.351 21.9716 108.254 21.9716 110.156 21.9716V12.1989L120.988 22Z"
                              fill="url(#paint14_linear)"/>
                        <path d="M138.724 2.08523C133.692 2.08523 130.285 2.08523 125.315 2.08523C125.315 8.67614 125.315 15.3239 125.315 21.9716C130.285 21.9716 133.968 21.9716 139 21.9716C139 20.4659 139 18.9318 139 17.4545C135.778 17.4545 133.937 17.4545 130.776 17.4545C130.776 16.2614 130.776 15.125 130.776 13.9602H138.079C138.079 12.4545 138.079 10.9489 138.079 9.44318H130.776V6.63068C133.937 6.63068 135.533 6.63068 138.724 6.63068C138.724 5.09659 138.724 3.5625 138.724 2.08523Z"
                              fill="url(#paint15_linear)"/>
                    </g>
                    <defs>
                        <filter id="filter0_i" x="0" y="1" width="67" height="21" filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                            <feColorMatrix in="SourceAlpha" type="matrix"
                                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="-1"/>
                            <feGaussianBlur stdDeviation="1"/>
                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"/>
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
                        </filter>
                        <filter id="filter1_i" x="69" y="1" width="70" height="21" filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                            <feColorMatrix in="SourceAlpha" type="matrix"
                                           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="-1"/>
                            <feGaussianBlur stdDeviation="1"/>
                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"/>
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
                        </filter>
                        <linearGradient id="paint0_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint3_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint4_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                        <linearGradient id="paint5_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                        <linearGradient id="paint6_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                        <linearGradient id="paint7_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                        <linearGradient id="paint8_linear" x1="104" y1="4" x2="104" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint9_linear" x1="104" y1="4" x2="104" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint10_linear" x1="104" y1="4" x2="104" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint11_linear" x1="104" y1="4" x2="104" y2="24"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2870A0"/>
                            <stop offset="1" stop-color="#144F77"/>
                        </linearGradient>
                        <linearGradient id="paint12_linear" x1="104" y1="2" x2="104" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                        <linearGradient id="paint13_linear" x1="104" y1="2" x2="104" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                        <linearGradient id="paint14_linear" x1="104" y1="2" x2="104" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                        <linearGradient id="paint15_linear" x1="104" y1="2" x2="104" y2="22"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#58D7FF"/>
                            <stop offset="1" stop-color="#18ACFF"/>
                        </linearGradient>
                    </defs>
                </svg>
            </router-link>
            <nav class="pc">
                <ul>
                    <li>
                        <a href="https://vk.com/vinepe" target="_blank">Мы ВКонтакте</a>
                    </li>
                    <li>
                        <p @click="openModal">Начать играть</p>
                    </li>
                </ul>
            </nav>

  <!--            <router-link :to="{name: 'profile'}" v-if="$auth.check()">
                  <secondary_button>Кабинет игрока</secondary_button>
              </router-link>
              <router-link :to="{name: 'login'}" v-else>
                  <secondary_button>Войти в кабинет</secondary_button>
              </router-link>-->
        </div>
        <template v-else>
            <div class="mobile-menu-modal header-modal-menu" :class="{open : openMobileMenu}">
                <nav>
                    <ul>
                        <li @click="openMobileMenu = false">
                            <router-link class="only-exact-link" :to="{name:'home'}">
                                <h2>Главная</h2>
                            </router-link>
                        </li>
<!--                        <li @click="openMobileMenu = false">
                            <router-link :to="{name:'profile'}">
                                <h2>Кабинет игрока</h2>
                            </router-link>
                        </li>-->
                        <li @click="openMobileMenu = false">
                            <h2>
                                <a href="https://vk.com/vinepe" target="_blank">
                                    Мы ВКонтакте
                                </a>
                            </h2>
                        </li>
                        <li @click="openModalAndCloseMenu">
                            <h2>Начать играть</h2>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="mobile-nav-modal header-modal-menu" :class="{open : openMobileNav}">
                <ul>
                    <li @click="openMobileNav = false">
                        <router-link :to="{name: 'profile'}">
                            <div class="svg-wrapper router btn">
                                <div class="cover-box">
                                    <svg width="20" height="20">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M13.7142 10.7125C15.1064 9.61372 16 7.91121 16 6C16 2.68629 13.3137 0 10 0C6.68629 0 4 2.68629 4 6C4 7.91121 4.8936 9.61372 6.28579 10.7125C2.60205 12.187 0 15.7896 0 20H2C2 15.5817 5.58172 12 10 12C14.4183 12 18 15.5817 18 20H20C20 15.7896 17.3979 12.187 13.7142 10.7125ZM14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z"/>
                                    </svg>
                                </div>
                                <h6>Профиль</h6>
                            </div>
                        </router-link>
                    </li>
                    <li @click="openMobileNav = false">
                        <router-link :to="{name: 'top_players'}">
                            <div class="svg-wrapper router">
                                <div class="cover-box">
                                    <svg width="20" height="21">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M13.3992 6.24196L10.9052 0.928618C10.5453 0.161814 9.45464 0.161815 9.09472 0.928619L6.60078 6.24196L0.923765 7.10933C0.119167 7.23226 -0.20937 8.21363 0.359042 8.7962L4.49997 13.0403L3.53312 18.9676C3.39873 19.7914 4.2733 20.4076 5.00387 20.0037L9.99997 17.242L14.9961 20.0037C15.7266 20.4076 16.6012 19.7914 16.4668 18.9676L15.5 13.0403L19.6409 8.79621C20.2093 8.21363 19.8808 7.23226 19.0762 7.10933L13.3992 6.24196ZM16.7132 8.8657L12.0689 8.15611L9.99997 3.74827L7.93104 8.15611L3.28676 8.8657L6.64798 12.3107L5.8564 17.1634L9.99997 14.8729L14.1435 17.1634L13.352 12.3107L16.7132 8.8657Z"/>
                                    </svg>
                                </div>
                                <h6>Топ игроков</h6>
                            </div>
                        </router-link>
                    </li>
                    <li @click="openMobileNav = false">
                        <router-link :to="{name: 'security'}">
                            <div class="svg-wrapper router">
                                <div class="cover-box">
                                    <svg width="18" height="20">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M8.68046 0.0597217L0.513792 3.23851C0.20275 3.35961 0 3.64429 0 3.96004V7.8243C0 13.1451 3.43037 17.9313 8.68508 19.9421C8.88692 20.0193 9.11304 20.0193 9.31492 19.9421C14.5695 17.9314 18 13.1452 18 7.8243V3.96004C18 3.64429 17.7973 3.35961 17.4862 3.23851L9.31954 0.0597217C9.11496 -0.0198877 8.885 -0.0199268 8.68046 0.0597217ZM9 17.9133C13.3069 16.0944 16 12.1235 16 7.8243V4.80619L9 2.08151L2 4.80619V7.8243C2 12.1235 4.69304 16.0944 9 17.9133Z"/>
                                    </svg>
                                </div>
                                <h6>Безопасность</h6>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>

            <div class="menu mobile-menu" :class="{fill : openMobileMenu || openMobileNav}">
              <div class="svg-wrapper static-hover router router-btn">
                <a href="https://vk.com/vinepe" target="_blank">
                  <div class="cover-box">
                    <svg width="20" height="20">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M13.7142 10.7125C15.1064 9.61372 16 7.91121 16 6C16 2.68629 13.3137 0 10 0C6.68629 0 4 2.68629 4 6C4 7.91121 4.8936 9.61372 6.28579 10.7125C2.60205 12.187 0 15.7896 0 20H2C2 15.5817 5.58172 12 10 12C14.4183 12 18 15.5817 18 20H20C20 15.7896 17.3979 12.187 13.7142 10.7125ZM14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z"/>
                    </svg>
                  </div>
                </a>
              </div>
<!--                <router-link v-if="$route.name === 'home'" :to="{name: 'profile'}">
                    <div @click="toggleMobileModal" class="svg-wrapper static-hover router router-btn">
                        <div class="cover-box">
                            <svg width="20" height="20">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M13.7142 10.7125C15.1064 9.61372 16 7.91121 16 6C16 2.68629 13.3137 0 10 0C6.68629 0 4 2.68629 4 6C4 7.91121 4.8936 9.61372 6.28579 10.7125C2.60205 12.187 0 15.7896 0 20H2C2 15.5817 5.58172 12 10 12C14.4183 12 18 15.5817 18 20H20C20 15.7896 17.3979 12.187 13.7142 10.7125ZM14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z"/>
                            </svg>
                        </div>
                    </div>
                </router-link>
                <router-link v-else :to="{name: 'home'}">
                    <div @click="toggleMobileModal" class="svg-wrapper router router-btn">
                        <div class="cover-box">
                            <img src="@/assets/icons/arrow_back.svg" alt="">
                        </div>
                    </div>
                </router-link>-->

                <button class="current-nav" v-if="$route.meta.name" :class="{'nav-open': openMobileNav}"
                        @click="toggleMobileModal('nav')">
                    <h3>{{$route.meta.name}}</h3>
                    <img src="@/assets/icons/arrow_head_bottom_blue.svg" alt="">
                </button>
                <router-link v-else :to="{name: 'home'}">
                    <div class="logo-tmp" @click="openMobileMenu = false">
                        <svg class="main-logo-shadow" width="140" height="24" viewBox="0 0 140 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.15501 4.08439H0V4.84388L8.99129 24H11.2691L20.1705 4.84388V4.08439H15.0155L10.2201 15.2236H10.0702L5.15501 4.08439Z"
                                  fill="url(#paint0_linear)"/>
                            <path d="M28.931 19.3587V8.47257H31.3886C31.3886 6.78481 31.3886 5.74402 31.3886 4.08439C27.9719 4.08439 24.5852 4.08439 21.1685 4.08439C21.1685 5.74402 21.1685 6.78481 21.1685 8.47257H23.6261V19.3587H20.9587C20.9587 21.0183 20.9587 22.2841 20.9587 24C24.5253 24 28.0319 24 31.5984 24C31.5984 22.2841 31.5984 21.0183 31.5984 19.3587H28.931Z"
                                  fill="url(#paint1_linear)"/>
                            <path d="M49.4071 24H51.3253V4.08439C49.4971 4.08439 47.6688 4.08439 45.8406 4.08439V13.7328L35.2309 4H33.2828V24C35.111 24 36.9692 24 38.8274 24V14.0985L49.4071 24Z"
                                  fill="url(#paint2_linear)"/>
                            <path d="M66.7303 4.08439C61.815 4.08439 58.4882 4.08439 53.633 4.08439C53.633 10.6104 53.633 17.4177 53.633 24C58.4882 24 62.0848 24 67 24C67 22.5091 67 20.7651 67 19.3024C63.853 19.3024 62.0548 19.3024 58.9678 19.3024C58.9678 18.121 58.9678 16.9958 58.9678 15.8425H66.1009C66.1009 14.3516 66.1009 12.8608 66.1009 11.3699H58.9678V8.58509C62.0548 8.58509 63.6133 8.58509 66.7303 8.58509C66.7303 7.0661 66.7303 5.54712 66.7303 4.08439Z"
                                  fill="url(#paint3_linear)"/>
                            <g filter="url(#filter0_i)">
                                <path d="M5.15501 2.08439H0V2.84388L8.99129 22H11.2691L20.1705 2.84388V2.08439H15.0155L10.2201 13.2236H10.0702L5.15501 2.08439Z"
                                      fill="url(#paint4_linear)"/>
                                <path d="M28.931 17.3587V6.47257H31.3886C31.3886 4.78481 31.3886 3.74402 31.3886 2.08439C27.9719 2.08439 24.5852 2.08439 21.1685 2.08439C21.1685 3.74402 21.1685 4.78481 21.1685 6.47257H23.6261V17.3587H20.9587C20.9587 19.0183 20.9587 20.2841 20.9587 22C24.5253 22 28.0319 22 31.5984 22C31.5984 20.2841 31.5984 19.0183 31.5984 17.3587H28.931Z"
                                      fill="url(#paint5_linear)"/>
                                <path d="M49.4071 22H51.3253V2.08439C49.4971 2.08439 47.6688 2.08439 45.8406 2.08439V11.7328L35.2309 2H33.2828V22C35.111 22 36.9692 22 38.8274 22V12.0985L49.4071 22Z"
                                      fill="url(#paint6_linear)"/>
                                <path d="M66.7303 2.08439C61.815 2.08439 58.4882 2.08439 53.633 2.08439C53.633 8.61041 53.633 15.4177 53.633 22C58.4882 22 62.0848 22 67 22C67 20.5091 67 18.7651 67 17.3024C63.853 17.3024 62.0548 17.3024 58.9678 17.3024C58.9678 16.121 58.9678 14.9958 58.9678 13.8425H66.1009C66.1009 12.3516 66.1009 10.8608 66.1009 9.3699H58.9678V6.58509C62.0548 6.58509 63.6133 6.58509 66.7303 6.58509C66.7303 5.0661 66.7303 3.54712 66.7303 2.08439Z"
                                      fill="url(#paint7_linear)"/>
                            </g>
                            <path d="M79.4329 12.6648L71.0252 4.02841H69V23.9716C70.8718 23.9716 72.7436 23.9716 74.6153 23.9716V15.108L79.1567 19.5398H79.7704L84.3425 15.108V23.9716C86.2142 23.9716 88.086 23.9716 89.9578 23.9716V4.02841H87.994L79.4329 12.6648Z"
                                  fill="url(#paint8_linear)"/>
                            <path d="M99.8307 19.5114V8.51705H102.347C102.347 6.8125 102.347 5.76136 102.347 4.08523C98.8488 4.08523 95.3814 4.08523 91.8833 4.08523C91.8833 5.76136 91.8833 6.8125 91.8833 8.51705H94.3995V19.5114H91.6685C91.6685 21.1875 91.6685 22.2386 91.6685 23.9716C95.32 23.9716 98.9102 23.9716 102.562 23.9716C102.562 22.2386 102.562 21.1875 102.562 19.5114H99.8307Z"
                                  fill="url(#paint9_linear)"/>
                            <path d="M120.988 24H122.952V4.08523C121.08 4.08523 119.208 4.08523 117.337 4.08523V13.8295L106.474 4H104.48V23.9716C106.351 23.9716 108.254 23.9716 110.156 23.9716V14.1989L120.988 24Z"
                                  fill="url(#paint10_linear)"/>
                            <path d="M138.724 4.08523C133.692 4.08523 130.285 4.08523 125.315 4.08523C125.315 10.6761 125.315 17.3239 125.315 23.9716C130.285 23.9716 133.968 23.9716 139 23.9716C139 22.4659 139 20.9318 139 19.4545C135.778 19.4545 133.937 19.4545 130.776 19.4545C130.776 18.2614 130.776 17.125 130.776 15.9602H138.079C138.079 14.4545 138.079 12.9489 138.079 11.4432H130.776V8.63068C133.937 8.63068 135.533 8.63068 138.724 8.63068C138.724 7.09659 138.724 5.5625 138.724 4.08523Z"
                                  fill="url(#paint11_linear)"/>
                            <g filter="url(#filter1_i)">
                                <path d="M79.4329 10.6648L71.0252 2.02841H69V21.9716C70.8718 21.9716 72.7436 21.9716 74.6153 21.9716V13.108L79.1567 17.5398H79.7704L84.3425 13.108V21.9716C86.2142 21.9716 88.086 21.9716 89.9578 21.9716V2.02841H87.994L79.4329 10.6648Z"
                                      fill="url(#paint12_linear)"/>
                                <path d="M99.8307 17.5114V6.51705H102.347C102.347 4.8125 102.347 3.76136 102.347 2.08523C98.8488 2.08523 95.3814 2.08523 91.8833 2.08523C91.8833 3.76136 91.8833 4.8125 91.8833 6.51705H94.3995V17.5114H91.6685C91.6685 19.1875 91.6685 20.2386 91.6685 21.9716C95.32 21.9716 98.9102 21.9716 102.562 21.9716C102.562 20.2386 102.562 19.1875 102.562 17.5114H99.8307Z"
                                      fill="url(#paint13_linear)"/>
                                <path d="M120.988 22H122.952V2.08523C121.08 2.08523 119.208 2.08523 117.337 2.08523V11.8295L106.474 2H104.48V21.9716C106.351 21.9716 108.254 21.9716 110.156 21.9716V12.1989L120.988 22Z"
                                      fill="url(#paint14_linear)"/>
                                <path d="M138.724 2.08523C133.692 2.08523 130.285 2.08523 125.315 2.08523C125.315 8.67614 125.315 15.3239 125.315 21.9716C130.285 21.9716 133.968 21.9716 139 21.9716C139 20.4659 139 18.9318 139 17.4545C135.778 17.4545 133.937 17.4545 130.776 17.4545C130.776 16.2614 130.776 15.125 130.776 13.9602H138.079C138.079 12.4545 138.079 10.9489 138.079 9.44318H130.776V6.63068C133.937 6.63068 135.533 6.63068 138.724 6.63068C138.724 5.09659 138.724 3.5625 138.724 2.08523Z"
                                      fill="url(#paint15_linear)"/>
                            </g>
                            <defs>
                                <filter id="filter0_i" x="0" y="1" width="67" height="21" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="-1"/>
                                    <feGaussianBlur stdDeviation="1"/>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"/>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
                                </filter>
                                <filter id="filter1_i" x="69" y="1" width="70" height="21" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="-1"/>
                                    <feGaussianBlur stdDeviation="1"/>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"/>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
                                </filter>
                                <linearGradient id="paint0_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint1_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint2_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint3_linear" x1="33.5" y1="4" x2="33.5" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint4_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                                <linearGradient id="paint5_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                                <linearGradient id="paint6_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                                <linearGradient id="paint7_linear" x1="33.5" y1="2" x2="33.5" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                                <linearGradient id="paint8_linear" x1="104" y1="4" x2="104" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint9_linear" x1="104" y1="4" x2="104" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint10_linear" x1="104" y1="4" x2="104" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint11_linear" x1="104" y1="4" x2="104" y2="24"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#2870A0"/>
                                    <stop offset="1" stop-color="#144F77"/>
                                </linearGradient>
                                <linearGradient id="paint12_linear" x1="104" y1="2" x2="104" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                                <linearGradient id="paint13_linear" x1="104" y1="2" x2="104" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                                <linearGradient id="paint14_linear" x1="104" y1="2" x2="104" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                                <linearGradient id="paint15_linear" x1="104" y1="2" x2="104" y2="22"
                                                gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#58D7FF"/>
                                    <stop offset="1" stop-color="#18ACFF"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                </router-link>

                <button class="hamburger hamburger--squeeze" :class="{'is-active': openMobileMenu}"
                        type="button" @click="toggleMobileModal('menu')">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </template>
        <div class="scroll-background-blocker" @click="toggleMobileModal"></div>

    </header>
</template>

<script>
    import secondary_button from '../elements/secondary_button.vue'
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "headerBlock",
        components: {
            secondary_button,
        },
        data: () => ({
            openMobileMenu: false,
            openMobileNav: false,
        }),
        computed: {
            anyModalOpen() {
                return this.openMobileMenu || this.openMobileNav;
            },
            ...mapGetters('window', ['pcVersion'])
        },
        watch: {
            anyModalOpen(open) {
                this.checkModalOpened(open);
            }
        },
        methods: {
            toggleMobileModal(toggle) {
                if (toggle === 'nav') {
                    this.openMobileNav = !this.openMobileNav;
                    this.openMobileMenu = false;
                } else if (toggle === 'menu') {
                    this.openMobileMenu = !this.openMobileMenu;
                    this.openMobileNav = false;
                } else {
                    this.openMobileMenu = false;
                    this.openMobileNav = false;
                }
            },
            checkModalOpened(open) {
                document.body.classList[open ? 'add' : 'remove']('fixed-scroll');
            },
            openModalAndCloseMenu(){
                this.toggleMobileModal();
                this.openModal();
            },
            ...mapMutations('modal_instruction', ['openModal'])
        }
    }
</script>

<style scoped lang="scss">
    header {
        .menu {
            padding-top: 32px;
            padding-bottom: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            @include tablet {
                padding: 0 24px;
                height: 70px;
                align-items: center;

                transition: 0.2s;
                transition-delay: 0.225s;
                &.fill {
                    background-color: $bg_light_plus;
                    transition: none;
                }
            }

            &.mobile-menu {
                .logo-tmp{
                    display: flex;
                    align-items: center;
                }
                position: relative;
                z-index: 100;

                button{
                    height: 70px;
                }

                @include tablet{
                    padding: 0 20px;
                    margin: 0 -20px;
                }

                @include mobile{
                    padding: 0;
                    margin: 0;
                }

                .router-btn {
                    padding: 25px;
                    min-width: 20px;
                }
            }
            .cover-box{
                width: 20px;
            }
            svg.main-logo-shadow {
                margin-right: 15px;

                @include tablet {
                    margin-right: 0;
                }
            }

            nav.pc ul {
                display: flex;
                margin-bottom: 0;
                line-height: 16px;

                li {
                    &:not(:last-child) {
                        margin-right: 48px;
                    }

                    a, p {
                        cursor: pointer;
                        transition: $transition;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 19px;
                        color: $text_gray;
                        margin-bottom: 0;

                        &:hover {
                            color: white;
                        }
                    }
                }
            }

            button.current-nav {
                display: flex;
                align-items: center;
                background: none;

                img {
                    transition: $transition;
                }

                &.nav-open img {
                    transform: scale(-1) rotate(-360deg);
                }

                h3 {
                    margin-right: 7px;
                }
            }
        }

        .hamburger-box{
            height: 20px;
        }

        /*@include tablet{
            .fixed-center{
                // logo mobile center
                position: absolute;
                left: 50%;
                right: 50%;
                transform: translate(-50%, -50%);
            }
        }*/
        .header-modal-menu {
            display: block;
            transition: $transition;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            transform: translateY(-100%);
            background-color: $bg_light;
            padding: 8px 24px;
            z-index: 99;

            &.open {
                transform: translateY(70px);
            }

            li:not(:last-of-type) {
                border-bottom: solid 1px $bg_line;
            }

            &.mobile-menu-modal {
                &.nav-open {
                    button.current-nav img {
                        transform: scale(-1) !important;
                    }
                }

                nav ul {
                    cursor: pointer;

                    a {

                        color: white;

                        &.router-link-exact-active {
                            h2 {
                                color: $blue !important;

                                &::after {
                                    content: url("~@/assets/icons/blue_dot.svg");
                                }
                            }
                        }
                    }

                    h2 {
                        cursor: inherit;
                        width: 100%;
                        padding: 16px 0;
                        margin-bottom: 0 !important;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        &::after {
                            content: url("~@/assets/icons/small_arrow_head.svg");
                            height: 26px;
                        }
                    }
                }
            }

            &.mobile-nav-modal {
                ul li {
                    padding: 16px 0;

                    .router {
                        position: relative;
                        display: flex;

                        h6 {
                            margin-left: 32px;
                        }
                    }

                    .router-link-exact-active {
                        .router::after {
                            content: url("~@/assets/icons/circle_checkmark.svg");
                            position: absolute;
                            top: 50%;
                            right: 0;
                            transform: translateY(-50%);
                            height: 22px;
                        }
                    }
                }
            }
        }
    }
</style>
